export * from './artist-registrar'
